import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import AuthService from "../services/auth.service";

const user = JSON.parse(localStorage.getItem("user"));

export const register = createAsyncThunk(
  "auth/register",
  async ({ firstName, lastName, email, password, matchingPassword }, thunkAPI) => {
    try {
      const response = await AuthService.register(firstName, lastName, email, password, matchingPassword);
      thunkAPI.dispatch(setMessage(response.data.message));
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
        console.log(error);
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const changePassword = createAsyncThunk(
  "user/changePassword",
  async ({ oldPassword, newPassword, matchingPassword }, thunkAPI) => {
    try {
      const response = await AuthService.changePassword(oldPassword, newPassword);
      thunkAPI.dispatch(setMessage(response.data.message));
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
        console.log(error);
        thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const resetPassword = createAsyncThunk(
  "user/resetPassword",
  async ({ newPassword, token }, thunkAPI) => {
    try {
      const response = await AuthService.resetPassword(newPassword, token);
      thunkAPI.dispatch(setMessage(response.data.message));
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
        console.log(error);
        thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const forgetPassword = createAsyncThunk(
  "user/forgetPassword",
  async ({ email }, thunkAPI) => {
    try {
      const response = await AuthService.forgetPassword(email);
      thunkAPI.dispatch(setMessage(response.data.message));
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
        console.log(error);
        thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const login = createAsyncThunk(
  "auth/login",
  async ({ username, password }, thunkAPI) => {
    try {
      const data = await AuthService.login(username, password);
      return { user: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
        console.log(error);
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const desktop_login = createAsyncThunk(
  "auth/desktop-login",
  async ({ clientId, machineId }, thunkAPI) => {
    try {
      const data = await AuthService.desktopLogin(clientId, machineId);
      return { user: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
        console.log(error);
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const inventory_service_login = createAsyncThunk(
  "auth/inventory-service-login",
  async ({ token }, thunkAPI) => {
    try {
      const data = await AuthService.inventoryServiceLogin(token);
      return { user: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
        console.log(error);
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async () => {
  await AuthService.logout();
});

const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: {
    [register.fulfilled]: (state, action) => {
      state.isLoggedIn = false;
    },
    [register.rejected]: (state, action) => {
      state.isLoggedIn = false;
    },
    [login.fulfilled]: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload.user;
    },
    [login.rejected]: (state, action) => {
      state.isLoggedIn = false;
      state.user = null;
    },
    [logout.fulfilled]: (state, action) => {
      state.isLoggedIn = false;
      state.user = null;
    },
    [inventory_service_login.fulfilled]: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload.user;
    },
    [inventory_service_login.rejected]: (state, action) => {
      state.isLoggedIn = false;
      state.user = null;
    },
  },
});

const { reducer } = authSlice;
export default reducer;
